"use client";

import { useLanguage } from "@/components/LanguageProvider";
import { CTASection } from "@/components/sections/CTASection";
import { SectionRenderer } from "@/components/sections/SectionRenderer";
import type { PageSection } from "@/lib/api";

export type PageCtaFallbackKeys = {
  heading: string;
  subheading: string;
  button: string;
};

type Props = {
  /** CMS `cta` section from getCmsPage; when set, renders instead of fallback. */
  cmsCta?: PageSection | null;
  fallback: PageCtaFallbackKeys;
  buttonUrl?: string;
};

export function PageBottomCta({
  cmsCta,
  fallback,
  buttonUrl = "/contact",
}: Props) {
  const { t } = useLanguage();

  if (cmsCta) {
    return <SectionRenderer section={cmsCta} />;
  }

  return (
    <CTASection
      data={{
        heading: t(fallback.heading),
        subheading: t(fallback.subheading),
        button_label: t(fallback.button),
        button_url: buttonUrl,
        style: "dark",
      }}
    />
  );
}
